import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';


import { MatSelect } from "@angular/material/select";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from 'src/app/models/case';
import { RequestTypeQualification } from 'src/app/models/requesttypequalification';
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { ValidationResult } from 'src/app/models/validation-result';
import { QualificationService } from 'src/app/services/qualifications.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';


@Component({
  selector: 'app-masterqualify-requesttype-mapping',
  templateUrl: './masterqualify-requesttype-mapping.component.html',
  styleUrls: ['./masterqualify-requesttype-mapping.component.css']
})
export class MasterqualifyRequesttypeMappingComponent implements OnInit {

	public selectedRecord: Case;
	public isEditing: boolean = false;
	busyCursor = false;
	public topCheck: boolean = false;

	public contentClassWithBanner: string | null = 'qualify-mapping-with-banner';
	public contentClassWithoutBanner: string | null = 'qualify-mapping-without-banner';
	public contentClassName: string | null = 'qualify-mapping-without-banner';

	public tableClassWithBanner: string | null = 'table-container-with-banner';
	public tableClassWithoutBanner: string | null = 'table-container-without-banner';
	public tableClassName: string | null = 'table-container-without-banner';

	public strErr: string = '';
	public requestTypeId: number = 0;

	public dataSource: MatTableDataSource<any>;
	records: any;
	public Idx: number | null = -1;
	public displayedColumns: string[] = ['selected', 'question', 'enable_auto_match', 'required'];
	public requestTypeQualificationsList: RequestTypeQualification[] = [];
	public editableQualifications: boolean = false;

	@Output() editEvent = new EventEmitter<any>();

	constructor(public serviceRequestsService: ServiceRequestsService, private qualificationsService: QualificationService) {

	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETTINGS_REQUEST_TYPE_QUALIFICATIONS", "WRITE")) {
			this.editableQualifications = true;			
		}
	}
	public onShowHandler(requestTypeId: number): void {
		this.requestTypeId = requestTypeId;
		this.queryRecords();
	}
	queryRecords() {

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
			this.tableClassName = this.tableClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
			this.tableClassName = this.tableClassWithoutBanner;
		}

		this.busyCursor = true;

		this.qualificationsService.getAllRequestTypeQualificationsByRequestTypeId(this.requestTypeId).subscribe(
			(result) => {
				this.requestTypeQualificationsList = result;
				let selected = 0;

				this.qualificationsService.getAllMasterQualifications().subscribe(
					(result1) => {
						this.busyCursor = false;
						this.records = [];
						for (const record of result1) {

							if(record.activeStatus !== 'Active') {
								continue;
							}

							const qualification = this.requestTypeQualificationsList.find(q => record.id === q.masterQualificationId);

							if (qualification) {
								selected++;
								record['selected'] = true;
								record['required'] = !!qualification.required;  // Convert to boolean
								record['useForAutomatch'] = !!qualification.useForAutomatch;  // Convert to boolean
							} else {
								record['required'] = false;
								record['useForAutomatch'] = false;
								record['selected'] = false;
							}
							this.records.push(record);
						}
						this.dataSource = new MatTableDataSource(this.records);
						if(selected === this.records.length) {
							this.topCheck = true;
						}
						else {
							this.topCheck = false;
						}
					},
					(error1) => {
						Settings.getInstance().handleError(error1, 'Error: unable to retrieve request types data from the' +
							' service');
						this.busyCursor = false;
					}
				);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve request types data from the' +
					' service');
				this.busyCursor = false;
			}
		);


	}

	public modifyHandler(): void {
		this.isEditing = true;

	}
	public nullSet(inp: string): string {
		if ((inp === undefined) || (inp === null)) {
			return '--';
		}
		return inp
	}

	public cancelClickedEvent(): void {
		this.isEditing = false;
		this.editEvent.emit(this.isEditing);
		this.queryRecords();
	}
	onRowClicked(row: any) {

	}
	saveClickedEvent() {
		const deleteRequest = this.qualificationsService.deleteAllRequestTypeQualificationsByRequestTypeId(this.requestTypeId);

		deleteRequest.pipe(
			switchMap(() => {
				const createRequests = [];

				for (const record of this.records) {
					let mapping: RequestTypeQualification = new RequestTypeQualification();
					mapping.id = 0;
					mapping.masterQualificationId = record.id;
					mapping.serviceRequestTypeId = this.requestTypeId;
					mapping.useForAutomatch = record['useForAutomatch'] ? 1 : 0; // Convert to 0 or 1
					mapping.required = record['required'] ? 1 : 0; // Convert to 0 or 1

					if (record['selected']===true) {
						createRequests.push(this.qualificationsService.createRequestTypeQualification(mapping));
					}
				}
				this.isEditing = false;
				return forkJoin(createRequests);
			})
		).subscribe(
			() => {
				this.isEditing = false;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to update date');
				this.busyCursor = false;
			}
		);
	}
	public toggleAllSelected(event:any): void {
		if (this.dataSource === undefined) {
			return;
		}

		for (const item of this.dataSource.filteredData) {
			item.selected = event.checked;
		}

	}
	onCheckboxChange(event: any, element: any) {
		if (element.useForAutomatch) {
			element.required = true;
		}
	}

}


